import type { DialogStore } from "@ariakit/react";
import { createContext, use } from "react";

export const SidenavContext = createContext<DialogStore | null>(null);

export function useSidenavStore() {
  const context = use(SidenavContext);

  if (!context) {
    throw new Error("Sidenav store not found in context.");
  }

  return context;
}
